exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes CU7Br{to{-webkit-transform:rotate(1turn)}}@keyframes CU7Br{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.h9bb_{padding-top:16px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.h9bb_._2d9Dx{border:2px solid #8b1313}.h9bb_ ._2NY6z{padding:8px 48px}.h9bb_ .-xfx7{-ms-flex:1 1;flex:1 1;-ms-flex-direction:row;flex-direction:row;display:-ms-flexbox;display:flex}@media only screen and (max-width:599px){.h9bb_ .-xfx7{-ms-flex-direction:column;flex-direction:column}}.h9bb_ .-xfx7 ._3n57p{-ms-flex:1 1;flex:1 1;padding:8px 24px}.h9bb_ ._17MZI{padding:24px 56px}.h9bb_ ._2U4uB{-ms-flex:1 1;flex:1 1;-ms-flex-direction:row;flex-direction:row;display:-ms-flexbox;display:flex;border-top:2px solid #ebebeb;padding:32px 24px 0 0;-ms-flex-pack:center;justify-content:center;margin-top:48px}@media only screen and (max-width:599px){.h9bb_ ._2U4uB{-ms-flex-direction:column;flex-direction:column}}.h9bb_ ._2U4uB ._1Edw2{padding-left:8px}@media only screen and (max-width:599px){.h9bb_ ._2U4uB ._1Edw2{padding-top:8px}}", ""]);

// exports
exports.locals = {
	"safecheck-success-modal": "h9bb_",
	"error": "_2d9Dx",
	"success-modal-content": "_2NY6z",
	"row": "-xfx7",
	"item": "_3n57p",
	"safecheck-phone-input": "_17MZI",
	"button-row": "_2U4uB",
	"button-content": "_1Edw2",
	"spin": "CU7Br"
};